import React from 'react';
import {useNavigation} from "../hooks/useNavigation";
import classnames from "classnames";
import {rehydrateState} from "../state/actions.mjs";

/**
 * Page loading component that avoids browser page load
 */
const Href = ({ className, children, shouldPush, shouldReUp, onClick, url, urlToMatch  }) => {
    const componentClass = 'href';
    const { loadPage, pushToNextPage} = useNavigation();
    const windowPath = window.location.pathname;
    const isMatch = windowPath.includes(urlToMatch || url);
    const classes = classnames(componentClass, className, {
        active: isMatch
    });

    const onNavClick = (e) => {
        e.preventDefault();
        onClick && onClick(url);
        if(shouldPush) {
            pushToNextPage(url, shouldReUp ? rehydrateState() : null);
        } else {
            loadPage(url, shouldReUp ? rehydrateState() : null);
        }
    };

    return <a className={classes} href={url} onClick={onNavClick}>
        { children }
    </a>
};

export default Href;
